import axios from 'axios';
import * as endPoints from '../../Constants/Endpoints'
import { DateTime } from 'luxon';

export function GetBarbers() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Barbers,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function CreateLeave(barberId, startDateTime, endDateTime) {
    const leaveDto = {
        barberId,
        startDateTime: toUnspecifiedLocalDateTimeString(startDateTime),
        endDateTime: toUnspecifiedLocalDateTimeString(endDateTime),
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Leave, leaveDto,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}

export function UpdateLeave(leaveId, barberId, startDateTime, endDateTime) {
    const leaveDto = {
        leaveId,
        barberId,
        startDateTime: toUnspecifiedLocalDateTimeString(startDateTime),
        endDateTime: toUnspecifiedLocalDateTimeString(endDateTime),
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Leave, leaveDto,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}

export function DeleteLeave(leaveId) {
    return axios.delete(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Leave,
    {
        params: { leaveId },
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetRoster(dateTime) {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Roster,
    { 
        params: {dateTime},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

function toUnspecifiedLocalDateTimeString(value) {
    if (!value) return value;

    const jsDate = value instanceof Date ? value : new Date(value);

    return DateTime.fromJSDate(jsDate).toFormat("yyyy-MM-dd'T'HH:mm:ss");
}